/**
 * TransportService - controls audio transport (play/stop/bpm)
 *
 * Transport is always local (client-side). Audio runs in the browser.
 */

import type { ITransport } from '@/runtime/ITransport';

export class TransportService {
  constructor(private transport: ITransport) {}

  async play(): Promise<void> {
    this.transport.start();
  }

  async pause(): Promise<void> {
    this.transport.pause();
  }

  async stop(): Promise<void> {
    this.transport.stop();
  }

  async setBpm(bpm: number): Promise<void> {
    this.transport.bpm.value = bpm;
  }

  getTime() { return this.transport.currentTime}

  getState(): { state: 'started' | 'stopped' | 'paused'; bpm: number } {
    return {
      state: this.transport.state,
      bpm: this.transport.bpm.value
    };
  }
}
